module.exports = __webpack_public_path__ + "static/media/popup.cfbfa53c.png";